import React from 'react';
import { Spinner } from './Spinner';
import './Button.css';

/**
 * Button — единственная кнопка системы.
 *
 *   variant: 'primary' | 'secondary' | 'ghost' | 'danger'
 *            ('outline' — старое имя secondary, 'success' — зелёная заливка
 *             «Завершить сборку»; новые экраны их не берут)
 *   size:    'sm' (28 px) | 'md' (36 px) | 'lg' (44 px — ТСД, палец в перчатке)
 *   icon / iconRight — компонент иконки lucide (icon={Plus}), не элемент
 *   loading  — спиннер вместо иконки, кнопка недоступна, текст остаётся
 *   fullWidth — на всю ширину контейнера
 *   iconOnly — квадратная кнопка без текста (обязателен aria-label/title)
 *
 * Правило экрана: одна primary. Удаление — danger, и лучше в меню «…» с
 * подтверждением. type не подставляем: кнопка внутри <form> остаётся submit,
 * как у обычного <button> (старые формы на это рассчитывают).
 */
const ICON_SIZE = { sm: 14, md: 16, lg: 18 };

export function Button({
  children,
  variant = 'secondary',
  size = 'md',
  loading = false,
  disabled = false,
  icon: Icon,
  iconRight: IconRight,
  fullWidth = false,
  iconOnly = false,
  className = '',
  ...props
}) {
  const isz = ICON_SIZE[size] || 16;
  const cls = [
    'ui-btn', `ui-btn--${variant}`, `ui-btn--${size}`,
    fullWidth && 'ui-btn--block',
    (iconOnly || (!children && (Icon || loading))) && 'ui-btn--icon-only',
    loading && 'ui-btn--loading',
    className,
  ].filter(Boolean).join(' ');
  return (
    <button
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading ? <Spinner size="sm" className="ui-btn__spinner" /> : Icon ? <Icon size={isz} aria-hidden="true" /> : null}
      {children !== undefined && children !== null && children !== false && <span className="ui-btn__label">{children}</span>}
      {IconRight && !loading && <IconRight size={isz} aria-hidden="true" />}
    </button>
  );
}
